export const RUN_NAMES_FILTER_TEXT = {
	outerLabel: 'Run Name',
	inputLabel: 'Run number',
	placeholder: 'E.g. 01, 02',
	infoError: 'Should contain only letters!',
	optionsLabel: 'Lines',
	optionSubtitle: 'Select to add',
};
